import { type ReactNode } from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout, type ProductKey } from './MetaPixel';
type FadeInProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
};
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.42,
    delay
  }} className={className} data-id="element-297" data-mp="185oyq0kc2ui1">
      {children}
    </motion.div>;
}
type CTAButtonProps = {
  href: string;
  children: ReactNode;
  fullWidth?: boolean;
  className?: string;
  trackingProduct?: ProductKey;
};
export function CTAButton({
  href,
  children,
  fullWidth = false,
  className = '',
  trackingProduct = 'megapack'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} onClick={() => {
    if (isExternal) trackInitiateCheckout(trackingProduct);
  }} rel={isExternal ? 'noopener noreferrer' : undefined} className={`inline-flex min-h-[48px] items-center justify-center rounded-xl bg-brandOrange px-6 py-3 font-sans text-[13px] font-extrabold uppercase tracking-wide text-white shadow-[0_8px_20px_rgba(140,18,60,0.2)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-brandOrange-hover focus:outline-none focus:ring-4 focus:ring-brandOrange/20 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-298" data-mp="20tkvf59wkmet">
      {children}
    </a>;
}
type SectionProps = {
  children: ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`overflow-hidden px-4 py-9 md:px-6 md:py-16 ${className}`} data-id="element-299" data-mp="2ctqo8yp1bksn">
      <div className="mx-auto max-w-[1100px]" data-id="element-300" data-mp="2crxgfg2oquj2">{children}</div>
    </section>;
}